define(function(require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('./templates/t_itv_login_guest.hbs');
	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
		},
		template: tpl,
		tagName: 'tr',
		className: 'v_itv_guest_item',
		modelEvents: {
			change: 'render'
		},
		events: {
		},
		
		templateHelpers: function(){
			return {
			}; 
		}
	});
});
